import { useCallback, useState } from 'react';

export function useResetSelectedRows() {
  const [lastResetSelectedRows, setLastResetSelectedRows] = useState(null);

  const resetSelectedRows = useCallback(() => {
    setLastResetSelectedRows(Date.now());
  }, []);

  return { lastResetSelectedRows, resetSelectedRows };
}
